<ng-template #rowActions let-intervention>
  <action-menu [items]="actionMenuItems" [actionData]="intervention"></action-menu>
  <!-- <a
    mat-icon-button
    [routerLink]="['/interventions', intervention.id]"
    aria-label="Detail"
    matTooltip="Detail"
    ><mat-icon>visibility</mat-icon></a
  > -->
</ng-template>
<data-table
  title="Interventions"
  searchLabel="Search interventions"
  searchPlaceholder="Number, member, customer or status"
  loadingMessage="Loading interventions..."
  emptyMessage="No interventions found."
  [rows]="interventions()"
  [columns]="columns"
  [actionsTemplate]="rowActions"
  [loading]="loading()"
  [showRefresh]="true"
  [searchEnabled]="true"
  [searchTerm]="searchTerm()"
  [paginationEnabled]="true"
  [pageNumber]="pageNumber()"
  [pageSize]="pageSize()"
  [totalCount]="totalCount()"
  [totalPages]="totalPages()"
  (refreshed)="refreshed.emit()"
  (searchChanged)="searchChanged.emit($event)"
  (pageChanged)="pageChanged.emit($event)"
/>
